/* eslint-disable no-console */
import React, { useState, useCallback, useEffect } from "react";
import {
  CotizadorProgrammaticCalculadora,
  CotizadorProgrammaticDuracion,
  CotizadorProgrammaticFrecuencia,
  CotizadorProgrammaticHorasOn,
  CotizadorProgrammaticInventario,
  CotizadorProgrammaticPlazo,
} from "../../components";
import "./stylesOnlineCotizador.scss";

export const CotizadorProgrammatic = () => {
  const [inventarioData, setInventarioData] = useState({
    ascensoresSeleccionados: 0,
    audienciaSeleccionadaAscensor: 0,
    audienciaSeleccionadaCowork: 0,
    audienciaSeleccionadaTotal: 0,
    audienciaSeleccionadaTotems: 0,
    coworkSeleccionados: 0,
    edificiosSeleccionadosAscensores: [],
    edificiosSeleccionadosCowork: [],
    edificiosSeleccionadosTotems: [],
    edificiosSeleccionadosEspera: [],
    esperaSeleccionados: 0,
    totemsSeleccionados: 0,
  });
  const [plazo, setPlazo] = useState(0);
  const [frecuencia, setFrecuencia] = useState("");
  const [horasSeleccionadas, setHorasSeleccionadas] = useState({
    horas: 0,
    intervalos: [],
    options: [],
  });
  const [duracion, setDuracion] = useState(0);
  const [isProgrammaticSelected, setIsProgrammaticSelected] = useState(false);
  const [isDigitalSelected, setIsDigitalSelected] = useState(false);
  const [resetInventario, setResetInventario] = useState(false);
  const [includeInstallingBuildings, setIncludeInstallingBuildings] = useState(false);
  const [resetCounter, setResetCounter] = useState(0); // Nuevo contador de reseteo

  useEffect(() => {
    // Esto asegura que la calculadora se actualice cuando cambian los valores
    setInventarioData((prev) => ({ ...prev })); // Forzar actualización del inventario
  }, [plazo, frecuencia, duracion, horasSeleccionadas, isProgrammaticSelected, isDigitalSelected]);

  const handleProgrammaticChange = (isProgrammatic) => {
    setIsProgrammaticSelected(isProgrammatic);
    setIsDigitalSelected(!isProgrammatic);
    setResetInventario(true);
    setInventarioData({
      ascensoresSeleccionados: 0,
      audienciaSeleccionadaAscensor: 0,
      audienciaSeleccionadaCowork: 0,
      audienciaSeleccionadaTotal: 0,
      audienciaSeleccionadaTotems: 0,
      coworkSeleccionados: 0,
      edificiosSeleccionadosAscensores: [],
      edificiosSeleccionadosCowork: [],
      edificiosSeleccionadosTotems: [],
      edificiosSeleccionadosEspera: [],
      esperaSeleccionados: 0,
      totemsSeleccionados: 0,
    });
    setHorasSeleccionadas({ horas: 0, intervalos: [], options: [] });
    setPlazo(0);
    setFrecuencia("");
    setDuracion(0);
    setResetCounter((prev) => prev + 1); // Incrementar el contador de reseteo
  };

  const handleDigitalChange = (isDigital) => {
    setIsDigitalSelected(isDigital);
    setIsProgrammaticSelected(!isDigital);
    setResetInventario(true);
    setInventarioData({
      ascensoresSeleccionados: 0,
      audienciaSeleccionadaAscensor: 0,
      audienciaSeleccionadaCowork: 0,
      audienciaSeleccionadaTotal: 0,
      audienciaSeleccionadaTotems: 0,
      coworkSeleccionados: 0,
      edificiosSeleccionadosAscensores: [],
      edificiosSeleccionadosCowork: [],
      edificiosSeleccionadosTotems: [],
      edificiosSeleccionadosEspera: [],
      esperaSeleccionados: 0,
      totemsSeleccionados: 0,
    });
    setHorasSeleccionadas({ horas: 0, intervalos: [], options: [] });
    setPlazo(0);
    setFrecuencia("");
    setDuracion(0);
    setResetCounter((prev) => prev + 1); // Incrementar el contador de reseteo
  };

  const handleResetInventarioComplete = () => {
    setResetInventario(false);
    // Forzar una actualización del inventario para que la calculadora lo detecte
    setInventarioData((prev) => ({ ...prev }));
  };

  const handleSubmitInventario = (data) => {
    setInventarioData(data);
  };

  const handlePlazoChange = (numberOfDays) => {
    setPlazo(numberOfDays);
  };

  const handleFrecuenciaChange = (selectedFrecuencia) => {
    setFrecuencia(selectedFrecuencia);
  };

  const handleHorasChange = useCallback((totalHours, selectedIntervals, selectedOptions = []) => {
    setHorasSeleccionadas({ horas: totalHours, intervalos: selectedIntervals, options: selectedOptions });
  }, []);

  const handleDuracionChange = (selectedDuracion) => {
    setDuracion(selectedDuracion);
  };

  const handleIncludeInstallingBuildingsChange = (isChecked) => {
    setIncludeInstallingBuildings(isChecked);
    setResetInventario(true);
  };

  const selectedOption = horasSeleccionadas.options.length > 0 ? horasSeleccionadas.options[0].label : "";

  return (
    <div className="online-cotizador-wrapper">
      <div className="calculator-original-fixed">
        <CotizadorProgrammaticCalculadora
          inventarioData={inventarioData}
          plazo={plazo}
          frecuencia={frecuencia}
          horasSeleccionadas={horasSeleccionadas}
          duracion={duracion}
          isProgrammaticSelected={isProgrammaticSelected}
          onIncludeInstallingBuildingsChange={handleIncludeInstallingBuildingsChange}
        />
      </div>
      <div className="controls-container">
        <div className="controls-row">
          <CotizadorProgrammaticHorasOn
            onHorasChange={handleHorasChange}
            onProgrammaticChange={handleProgrammaticChange}
            onDigitalChange={handleDigitalChange}
            onOptionChange={(option) =>
              handleHorasChange(horasSeleccionadas.horas, horasSeleccionadas.intervalos, [{ label: option }])
            }
            isProgrammaticSelected={isProgrammaticSelected}
            isDigitalSelected={isDigitalSelected}
            defaultHoras={0}
            defaultIntervalos={[]}
            defaultOptions={[]}
          />
          <CotizadorProgrammaticInventario
            onSubmit={handleSubmitInventario}
            isProgrammaticSelected={isProgrammaticSelected}
            resetInventario={resetInventario}
            onResetComplete={handleResetInventarioComplete}
            includeInstallingBuildings={includeInstallingBuildings}
          />
          <CotizadorProgrammaticPlazo
            onPlazoChange={handlePlazoChange}
            plazo={plazo}
            resetCounter={resetCounter} // Pasar el contador de reseteo
          />
          <CotizadorProgrammaticFrecuencia
            onFrecuenciaChange={handleFrecuenciaChange}
            isProgrammaticSelected={isProgrammaticSelected}
            isDigitalSelected={isDigitalSelected}
            selectedOption={selectedOption}
            frecuencia={frecuencia}
            plazo={plazo}
            resetCounter={resetCounter} // Pasar el contador de reseteo
          />
          <CotizadorProgrammaticDuracion
            onDuracionChange={handleDuracionChange}
            duracion={duracion}
            resetCounter={resetCounter} // Pasar el contador de reseteo
          />
        </div>
      </div>
    </div>
  );
};
